import { useRef } from 'react';
import { useEditorContext } from './EditorContext';
export const useInsertTarget = () => {
    const { setInsertTarget } = useEditorContext();
    const callbacksRef = useRef(new Map());
    const registerField = (fieldKey, onInsert, personalization) => {
        callbacksRef.current.set(fieldKey, onInsert);
        return (e) => {
            setInsertTarget({
                element: e.currentTarget,
                selectionStart: e.currentTarget.selectionStart ?? e.currentTarget.value.length,
                selectionEnd: e.currentTarget.selectionEnd ?? e.currentTarget.value.length,
                personalization,
                onInsert: (val) => callbacksRef.current.get(fieldKey)?.(val)
            });
        };
    };
    const clearInsertTarget = () => setInsertTarget(null);
    return { registerField, clearInsertTarget };
};
